import React from 'react';
import { MenuItem } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { buildUrlQueryParams, getTranslateByKey, isShowControlByElementId } from '@/main/services/utils';
import { RoutesConstants } from '@/main/routes/routesConstants';
import { Controls } from '@/main/services/constants/constantsControl';
import { ProcurementStatusEnum } from '@/main/services/enum/StatusProcurement';
import { OrderStatusEnum } from '@/main/services/enum/OrderStatusEnum';
import { useThreeDotsPartClaimContext } from '../context';
import OptionEmptySearchClaim from '../optionEmptySearchClaim';

interface IOptionReassignPartSearchClaimProps {
  guidQuote: string;
  guidPart: string;
  guidQuoteProcurement: string;
  guidProcurementSupplierItem: string;
  externalPartId: string;
  claimNumber: string;
  isStripePayment: boolean;
  idStatus: number;
  cancelationPending: boolean;
}
function OptionReassignPartSearchClaim({
  guidQuote,
  externalPartId,
  guidPart,
  guidProcurementSupplierItem,
  guidQuoteProcurement,
  idStatus,
  isStripePayment,
  claimNumber,
  cancelationPending
}: IOptionReassignPartSearchClaimProps) {
  const {
    generateIdMenu,
    closeThreeDotsPartClaim
  } = useThreeDotsPartClaimContext();
  const navigate = useNavigate();

  const showReassignButtonByStatus = [
    OrderStatusEnum.Assigned,
    OrderStatusEnum.Delivered,
    OrderStatusEnum.Received,
    OrderStatusEnum.Invoiced,
    OrderStatusEnum.Paid,
    OrderStatusEnum.Transit
  ];
  const showReassignButton =
    isShowControlByElementId(Controls.IdReassignPart)
    && (idStatus !== ProcurementStatusEnum.Paid)
    && showReassignButtonByStatus.includes(idStatus)
    && !isStripePayment
    && !cancelationPending;

  function handleReassignPart() {
    const routeReassignOrder = buildUrlQueryParams(
      RoutesConstants.orderReassignOrder,
      {
        guidQuote,
        guidPart,
        guidQuoteProcurement,
        guidProcurementSupplierItem,
        externalPartId,
        previousRoute: RoutesConstants.claimSearchClaims,
      }
    );
    navigate(routeReassignOrder);
    closeThreeDotsPartClaim()
  }

  if (!showReassignButton) return <OptionEmptySearchClaim option='OptionReassign' />;
  return (
    <MenuItem
      id={generateIdMenu('reassign')}
      onClick={handleReassignPart}
    >
      {getTranslateByKey('information.reassignPartToAnotherSupplier')}
    </MenuItem>
  )
}

export default OptionReassignPartSearchClaim;
